import { useBreadcrumb } from "features/breadcrumbs";
import ListaAnuncios from "./components/ListaAnuncios/index";
import Container from "components/Container";

function AnunciosListaPage() {
  useBreadcrumb([
    { name: "Administração", url: "/administracao" },
    { name: "Anúncios", url: "/administracao/anuncios" },
  ]);
  return (
    <Container>
      <ListaAnuncios />
    </Container>
  );
}

export default AnunciosListaPage;
